import * as React from 'react';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import CardActions from '@mui/joy/CardActions';
import CardOverflow from '@mui/joy/CardOverflow';
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import { PhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css';
import { add } from "../../service/clientService";
import { Button } from 'primereact/button';
import DropdownApi from '../../components/DropdownApi';
import { UserSession } from '../../models/UserSession';
import AssignmentRoundedIcon from '@mui/icons-material/AssignmentRounded';
import { NprLookup } from '../../service/api-service';
import S3ImagePreview from '../../components/S3ImagePreview';
import { Avatar } from 'primereact/avatar';
import { placeholder } from '../../assets/placeholder';
import MultiDropdownApi from '../../components/MultiDropdownApi';
import ImageS3Upload from '../../components/ImageS3Upload';
import { v4 as uuid } from 'uuid';
import { addEquipment, updateEquipment } from '../../service/equipmentService';
import { InputTextarea } from 'primereact/inputtextarea';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { Grid } from '@mui/material';
import { InputText } from 'primereact/inputtext';
import IntervalDropdown from '../../components/IntervalDropdown';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { equipmentImport, getEquipmentList } from '../../service/equipmentListService';



export default function EquipmentImport(modalProps: any) {

  const session: UserSession = modalProps.session;

  async function Add() {
    console.log("records == ", records);
    modalProps.setGlobalLoading(true);
    let ids = records.map((e: any) => e.id);

    equipmentImport(ids).then((r: any) => {
      modalProps.setGlobalLoading(false);
      modalProps.toast.current.show({ severity: 'success', summary: 'Equipment Added Successfully', life: 3000 });
      modalProps.setReload(!modalProps.reload);
      modalProps.setVisible(false);
    }).catch((error) => {
      modalProps.setGlobalLoading(false);
      modalProps.toast.current.show({ severity: 'error', summary: 'Failed to create Equipment', life: 3000 });
      modalProps.setVisible(false);
      console.log("error == ", error);
    });

  }

  const loadLazyData = (type: string) => {
    if (!type) return;
    getEquipmentList(equipmentType).then(data => {
      console.log("dropdownViewGet == ", data);
      setData(data);
    }).catch((error) => {
      console.log("error == ", error);
      setData([]);
    });
  }

  const [equipmentType, setEquipmentType] = React.useState("");
  const [data, setData] = React.useState([]);
  const [records, setRecords] = React.useState([]);


  React.useEffect(() => {
    loadLazyData(equipmentType);
  }, [equipmentType])

  const imageBodyTemplate = (item: any) => {
    return <Avatar image={item.photo} style={{ width: 30 }} />;
  };

  return (
    <React.Fragment>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <DropdownApi apiPath='equipment-type' optionLabel="name" optionValue='id' label='Equipment Type' selectedData={equipmentType} setSelectedData={setEquipmentType} />
        </Grid>
        <br />
        <Grid item xs={12}>
          <div className="card">
            <DataTable value={data} tableStyle={{ width: '100%' }}
              columnResizeMode="expand" showGridlines size="small"
              selectionMode="checkbox"
              selection={records}
              onSelectionChange={(e) => setRecords(e.value)}
              dataKey="id"
            >
              <Column selectionMode="multiple" headerStyle={{ width: '3rem' }}></Column>
              <Column header="Image" body={imageBodyTemplate}></Column>
              <Column field="name" header="Name"></Column>
              <Column field="description" header="description"></Column>
              <Column field="equipment_type_name" header="Equipment Type"></Column>
              <Column field="hazard_list" header="Hazard"></Column>
            </DataTable>
          </div>
        </Grid>
      </Grid>
      <br /><br />
      <CardOverflow style={{ width: '100%' }} sx={{ borderTop: '1px solid', borderColor: 'divider' }}>
        <CardActions style={{ marginTop: 15 }} sx={{ alignSelf: 'flex-end', pt: 2 }}>
          <Button type="button" icon="pi pi-file-import" label="Import" className="p-button-outlined" size="small" style={{ position: 'absolute', fontSize: 'small', right: 0, color: "#1E1A34" }} onClick={() => Add()} />
        </CardActions>
      </CardOverflow>
    </React.Fragment>
  );
}